import { render, staticRenderFns } from "./PlateValidationModal.vue?vue&type=template&id=1b5f2eac&scoped=true"
import script from "./PlateValidationModal.vue?vue&type=script&lang=js"
export * from "./PlateValidationModal.vue?vue&type=script&lang=js"
import style0 from "./PlateValidationModal.vue?vue&type=style&index=0&id=1b5f2eac&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5f2eac",
  null
  
)

export default component.exports